/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'section-title',
};
